import { serviceHandler } from './service-executor';

const TRUCK_URL = '/api/trucks';

export const getTrucks = () => {
  let URL = `${TRUCK_URL}`;
  return serviceHandler(URL, 'GET');
};

export const getTruckById = (truckId) => {
  let URL = `${TRUCK_URL}/${truckId}`;
  return serviceHandler(URL, 'GET');
};

export const search = (name) => {
  const URL = `${TRUCK_URL}/search?searchTerm=${name}`;
  return serviceHandler(URL, 'GET');
};

export const save = truck => {
  const URL = `${TRUCK_URL}`;
  return serviceHandler(URL, 'POST', truck);
};

export const update = truck => {
  const truckId = truck.id;
  const URL = `${TRUCK_URL}/${truckId}`;
  return serviceHandler(URL, 'PUT', truck);
};